import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ArrowDownUnderline({ idVariant = '', className }: Props) {
  return (
    <IconBase name="arrow-down-underline" w={20} className={className}>
      <path d="M2.5 15.8332H17.5V17.4998H2.5V15.8332ZM10.8333 10.9762L15.8926 5.91692L17.0711 7.09544L10 14.1665L2.92893 7.09544L4.10744 5.91692L9.16667 10.9762V1.6665H10.8333V10.9762Z" fill="currentColor"/>
    </IconBase>
  )
}

export default ArrowDownUnderline
